import { GameStatus } from '@adgf/shared';
import type { GameManifest } from '@adgf/shared';

/**
 * Game Manifest for "Mini Puzzle".
 *
 * A compact 3x3 sliding number puzzle. Score rewards few moves and a
 * fast solve.
 */
const manifest: GameManifest = {
  id: '55555555-5555-5555-5555-555555555555',
  slug: 'mini-puzzle',
  title: 'Mini Puzzle',
  description:
    'Slide the numbered tiles into order. Fewer moves and a faster solve earn a higher score.',
  version: '0.1.0',
  template_id: null,
  runtime: 'phaser',
  status: GameStatus.DRAFT,
  difficulty: 'medium',
  duration: 120,
  features: ['puzzle', 'slide', 'moves-tracking', 'timer', 'retry', 'touch-support'],
  entrypoint: '@adgf/game-mini-puzzle',
  analytics_schema: {
    move: 'number',
    moves_total: 'number',
    solve_seconds: 'number',
    won: 'number',
  },
};

export default manifest;
